<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M12 8.25A2.24 2.24 0 0 0 14.242 6 2.247 2.247 0 1 0 9.75 6 2.247 2.247 0 0 0 12 8.25Zm-6 0A2.24 2.24 0 0 0 8.242 6 2.247 2.247 0 1 0 3.75 6 2.247 2.247 0 0 0 6 8.25Zm0 1.5c-1.747 0-5.25.877-5.25 2.625v1.875h10.5v-1.875c0-1.748-3.503-2.625-5.25-2.625Zm6 0c-.217 0-.465.015-.727.037.87.63 1.477 1.478 1.477 2.588v1.875h4.5v-1.875c0-1.748-3.502-2.625-5.25-2.625Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
